import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@workos-inc/authkit-react'
import { Loader } from '@/components/ui/loader'
import { toast } from 'sonner'

export function AuthCallbackPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { user, isLoading } = useAuth()

  useEffect(() => {
    const handleCallback = async () => {
      // Check for error in URL params
      const error = searchParams.get('error')
      if (error) {
        const errorDescription =
          searchParams.get('error_description') || 'Authentication failed'
        toast.error(errorDescription)
        navigate('/sign-in')
        return
      }

      // Wait for auth to complete
      if (!isLoading && user) {
        // Get the return path from state or default to dashboard
        const state = searchParams.get('state')
        let returnPath = '/dashboard'

        if (state) {
          try {
            const stateData = JSON.parse(atob(state))
            returnPath = stateData.returnPath || '/dashboard'
          } catch {
            // If state parsing fails, use default
          }
        }

        navigate(returnPath)
      }
    }

    if (!isLoading) {
      handleCallback()
    }
  }, [isLoading, user, navigate, searchParams])

  return (
    <div className="h-screen overflow-hidden bg-[linear-gradient(146deg,_#d3f9ff_0%,_#a6eeeb_100%)]">
      <div className="flex min-h-screen items-center justify-center">
        <Loader text="Completing authentication..." className="text-primary" />
      </div>
    </div>
  )
}
